import { forwardRef } from 'react';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.secondaryAccent.contrastText,
    transition: theme.transitions.create('background-color'),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.secondaryAccent.light,
    },
    fontWeight: 'light',
    padding: theme.spacing(0.5, 12),
    borderRadius: theme.artistActionButtons.borderRadius,
    textTransform: 'capitalize',
    fontSize: '1rem',
    '& span': {
      textTransform: 'initial',
      display: 'flex',
    },
    '&[disabled]': {
      backgroundColor: theme.palette.secondaryAccent.extraLight,
      color: `${theme.palette.secondaryAccent.contrastText} !important`,
    },
  },
}));

export const CallToActionGreen = forwardRef((props, ref) => {
  const classes = useStyles();
  const extraClasses = Array.isArray(props.classes)
    ? props.classes
    : [props.classes];

  return (
    <Button
      ref={props.forwardedRef}
      className={[classes.button, extraClasses].join(' ')}
      onClick={(e) => props.onClickHandler?.(e)}
      disabled={props.disabled}
    >
      <Typography variant='button'>
        {props.icon && props.icon(classes.buttonIcon)}
        {props.label}
      </Typography>
    </Button>
  );
});
